<script setup lang="ts">
import './assets/style.scss'
import { onMounted, onUnmounted, type PropType, ref } from 'vue'
import { VPreloader } from '@/shared/ui'

const props = defineProps({
  scrollContainer: {
    type: String,
    required: true,
  },
  items: {
    type: Object as PropType<any[]>,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const container = ref<HTMLElement | null>(null)
const element = ref<HTMLElement | null>()
let scrolled = false

const emits = defineEmits(['ended', 'scrolled'])

/**
 * Функция инициатор окончания прокрутки
 */
const scrollHandler = () => {
  if (!container.value || !element.value) return

  const scroll = container.value.scrollTop
  const height = container.value.clientHeight
  const dataHeight = element.value.offsetHeight

  if (scroll + height >= dataHeight) {
    if (!scrolled && props.items?.length < props.total) {
      emits('scrolled')
      scrolled = true
    }

    if (props.items?.length === props.total) {
      emits('ended')
    }
  } else {
    scrolled = false
  }
}

/** Регистрируем события при монтировании */
onMounted(() => {
  container.value = document.querySelector(props.scrollContainer)
  container.value?.addEventListener('scroll', scrollHandler)
})

/** Регистрируем события при размонтировании */
onUnmounted(() => {
  container.value?.removeEventListener('scroll', scrollHandler)
})
</script>

<template>
  <div class="v-scroll" v-bind="$attrs" ref="element">
    <template v-for="item in items" :key="item.id">
      <slot name="item" :item="item" />
    </template>

    <slot />
  </div>

  <VPreloader v-if="loading" :wrapper-height="80" />
</template>
